"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LinkTabs_component_exports = {};
__export(LinkTabs_component_exports, {
  LinkTabs: () => LinkTabs
});
module.exports = __toCommonJS(LinkTabs_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_clsx = __toESM(require("clsx"));
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_react = require("react");
var import_Select = require("@greatmindsorg/gmui-lib/dist/components/Select/Select.component");
var import_SelectOption = require("@greatmindsorg/gmui-lib/dist/components/Select/SelectOption.component");
const LinkTabs = ({ items, defaultIndex = 0 }) => {
  const { isMd, isLg, isXl } = (0, import_useBreakpoints.useBreakpoints)();
  const [focusedIndex, setFocusedIndex] = (0, import_react.useState)(null);
  if (items.length === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "flex-1", "data-testid": "linktabs-empty-state" });
  }
  const handleClick = (url) => {
    if (url) window.location.href = url;
  };
  return isLg || isXl ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("nav", { className: "gmui-tabs-tablist-container flex h-full flex-1 items-center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "border-0 border-l border-solid border-neutral100 py-4" }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("ul", { className: "flex h-full list-none", children: items.map((item, index) => {
      const isFocused = focusedIndex === index;
      const isSelected = index === defaultIndex;
      const styleTab = (0, import_clsx.default)([
        "box-border h-full items-center flex justify-center no-underline",
        "gmui-tabs-tab",
        `${isSelected ? "font-style-body-medium" : "font-style-body"}`,
        {
          "gmui-tabs-tab-selected": isSelected,
          "gmui-tabs-tab-not-selected": !isSelected,
          "gmui-tabs-tab-focused": isFocused
        }
      ]);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "a",
        {
          href: item.href,
          className: styleTab,
          "aria-current": index === defaultIndex ? "page" : void 0,
          onFocus: () => setFocusedIndex(index),
          onBlur: () => setFocusedIndex(null),
          children: item.label
        }
      ) }, index);
    }) })
  ] }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: isMd ? "mx-4 w-[400px] justify-items-end" : "mx-0 lg:mx-4", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_Select.Select,
    {
      id: "select-id",
      defaultIndex,
      singleSelect: false,
      simpleSelect: false,
      toggleButtonClassName: "flex-1 px-2",
      floatingMargin: { top: "9px" },
      showHamburgerMenu: true,
      children: items.map((op, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_SelectOption.SelectOption,
        {
          label: op.label,
          onClick: () => handleClick(op.href),
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "flex items-center gap-2", children: op.label }, index)
        },
        `op-${index}`
      ))
    }
  ) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  LinkTabs
});
//# sourceMappingURL=LinkTabs.component.js.map